import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors } from '../../shared/theme/ticketColors';
import { ModalShell } from '../../shared/modals/ModalShell'
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import { posSharedUi as posUi } from '../../shared/ui/posSharedUi';

type Props = {
  visible: boolean;
  entrySupplierId: string | null;
  suppliers: Array<{ id: string; name: string }>;
  onClose: () => void;
  onSelectSupplier: (supplierId: string | null) => void;
};

export const AddStockModalSupplierPicker = ({
  visible,
  entrySupplierId,
  suppliers,
  onClose,
  onSelectSupplier,
}: Props) => (
  <ModalShell
    visible={visible}
    onClose={onClose}
    appearance="ticket"
    kicker="Stock"
    title="Proveedor"
    keyboardAvoiding={false}
    widthVariant="compact"
    footer={
      <TouchableOpacity style={posUi.secondaryButton} onPress={onClose}>
        <Text style={posUi.secondaryButtonText}>Listo</Text>
      </TouchableOpacity>
    }
  >
    <View style={{ gap: 2 }}>
      <TouchableOpacity
        style={[modalExperience.pickerRow, entrySupplierId === null && modalExperience.pickerRowActive]}
        onPress={() => onSelectSupplier(null)}
        accessibilityRole="button"
      >
        <Text style={[modalExperience.pickerRowText, entrySupplierId === null && modalExperience.pickerRowTextActive]}>
          Sin proveedor
        </Text>
        {entrySupplierId === null ? (
          <Ionicons name="checkmark-circle" size={22} color={ticketColors.ok} />
        ) : null}
      </TouchableOpacity>
      {suppliers.map((supplier) => (
        <TouchableOpacity
          key={supplier.id}
          style={[modalExperience.pickerRow, entrySupplierId === supplier.id && modalExperience.pickerRowActive]}
          onPress={() => onSelectSupplier(supplier.id)}
          accessibilityRole="button"
        >
          <Text
            style={[modalExperience.pickerRowText, entrySupplierId === supplier.id && modalExperience.pickerRowTextActive]}
            numberOfLines={1}
          >
            {supplier.name}
          </Text>
          {entrySupplierId === supplier.id ? (
            <Ionicons name="checkmark-circle" size={22} color={ticketColors.ok} />
          ) : null}
        </TouchableOpacity>
      ))}
    </View>
  </ModalShell>
);
